import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { ProxyUserTableFilterSchema } from "./_list/-zod-schema";

export const Route = createFileRoute("/_staff/id-managements/_layout/")({
  validateSearch: zodValidator(ProxyUserTableFilterSchema),
});
